export const Dashicon2 = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.50003C6.06294 1.50003 1.25 6.31297 1.25 12.25C1.25 18.1871 6.06294 23 12 23C17.9371 23 22.75 18.1871 22.75 12.25C22.75 6.31297 17.9371 1.50003 12 1.50003ZM12.75 8.25003C12.75 7.83581 12.4142 7.50003 12 7.50003C11.5858 7.50003 11.25 7.83581 11.25 8.25003V12.4559C11.25 12.7747 11.1282 13.0814 10.9095 13.3134L9.4543 14.8569C9.17015 15.1582 9.18412 15.6329 9.4855 15.9171C9.78689 16.2012 10.2616 16.1872 10.5457 15.8858L12.0009 14.3424C12.482 13.8321 12.75 13.1572 12.75 12.4559V8.25003Z"
          fill="#4E9E8F"
        />
        <path
          d="M5.96852 1.83568C6.29197 1.57692 6.34441 1.10495 6.08565 0.781506C5.82689 0.45806 5.35493 0.405619 5.03148 0.664376L2.53148 2.66438C2.20803 2.92313 2.15559 3.3951 2.41435 3.71855C2.67311 4.042 3.14507 4.09444 3.46852 3.83568L5.96852 1.83568Z"
          fill="#4E9E8F"
        />
        <path
          d="M18.9685 0.664376C18.6451 0.405619 18.1731 0.45806 17.9143 0.781506C17.6556 1.10495 17.708 1.57692 18.0315 1.83568L20.5315 3.83568C20.8549 4.09444 21.3269 4.042 21.5857 3.71855C21.8444 3.3951 21.792 2.92313 21.4685 2.66438L18.9685 0.664376Z"
          fill="#4E9E8F"
        />
      </svg>
    </>
  );
};
